import React from 'react'
import { Platform, View } from 'react-native'
import * as Linking from 'expo-linking'
import { useNavigation } from '@react-navigation/native'
import tw from 'tailwind-rn'

import { BlockMenuType } from '../../config/types'
import { HGListItem } from '../HGUI'
import { ListItemType, ListItemCategory } from '../HGUI/HGListItem'

type Props = {
  data: BlockMenuType
  // title?: string
}

const BlockMenu = (props: Props) => {
  const { data } = props
  const { items } = data
  const navigation = useNavigation()

  return (
    <View style={tw('pb-6')}>
      {items.map((m) => {
        const listItemData: ListItemType = {
          type: ((): ListItemCategory => {
            if (m.type === 'resource') return 'link'
            if (m.type === 'external-url') {
              return m.isDownloadable ? 'download' : 'link'
            }
            // if (m.type === 'custom') return 'custom'
            return 'link'
          })(),
          title: m.title,
          description: m.description,
          disabled: false,
          onPress: () => {
            // External links
            if (m.type === 'external-url' || m.type === 'download') {
              if (m.url) Linking.openURL(m.url)
            }

            // Internal links
            if (m.type === 'resource') {
              navigation.push('GenericResource', {
                // params
                resourceId: m.resourceId,
                slug: m.slug,
                ...(Platform.OS !== 'web' && { name: m.title }),
              })
            }

            // Suspicion checker tool
            if (m.type === 'suspicion-checker') {
              navigation.push()
            }

            // Locations of an district
            if (m.type === 'locations') {
              navigation.push('GenericLocations', {
                districtId: m.districtId,
                locationTypes: m.locationTypes,
                name: m.title,
              })
            }

            // Custom routing
            if (m.type === 'custom') {
              navigation.push(m.routeName, {
                districtId: m.districtId,
                name: m.title,
              })
            }
          },
        }

        return <HGListItem key={m.id} item={listItemData} />
      })}
    </View>
  )
}

export default BlockMenu
